import { Grid } from "@mui/material";
import { Children, useEffect } from "react";
import { useContextLandingPages } from "src/Contexts/LandingPageContext/LandingPagesContext";
import { CardLandingPage } from "src/Pages/components/CardLandingPage/CardLandingPage";
import { listLandingPagesRoot } from "src/Pages/components/LandingPages";
import { UseGetLandingPages } from "./Hooks/UseGetLandingPages";

export const TablesLandingPages = () => {
  const { listLandingPages } = useContextLandingPages();
  const { handleGet } = UseGetLandingPages();

  useEffect(() => {
    handleGet();
  }, []);

  const landingPagesFiltradas = listLandingPagesRoot.filter((landingPage) =>
    listLandingPages.some((item) => item.id === landingPage.id)
  );

  return (
    <Grid container spacing={4}>
      {Children.toArray(
        landingPagesFiltradas.map((item) => (
          <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
            <CardLandingPage
              id={String(item.id)}
              title={item.titleInternal}
              landingPageComponent={item.landingPageComponent}
            />
          </Grid>
        ))
      )}
    </Grid>
  );
};
